import transcript from '@/api/transcript'
import downloadFile from '@/libs/core/downloadFile'
import get from 'lodash/get'

// 優先使用後端 Content-Disposition 給的檔名（含部門名稱與副檔名），讀不到時才用前端預設檔名
function filenameFromResponse(response, fallback) {
  const disposition = get(response, ['headers', 'content-disposition'], '')
  const match = /filename*=UTF-8''([^;]+)/i.exec(disposition)
  if (!match) return fallback
  try {
    return decodeURIComponent(match[1])
  } catch (e) {
    return fallback
  }
}

function downloadExportedReports(response, fallbackFilename) {
  downloadFile(response.data, filenameFromResponse(response, fallbackFilename))
}

function todayDateSuffix() {
  const now = new Date()
  const y = now.getFullYear()
  const m = String(now.getMonth() + 1).padStart(2, '0')
  const d = String(now.getDate()).padStart(2, '0')
  return `${y}${m}${d}`
}

const INITIAL_STATE = {
  deptList: {},
  userList: {},
}

export default {
  namespace: 'transcript',

  state: INITIAL_STATE,

  reducers: {
    init() {
      return { ...INITIAL_STATE }
    },
    setDeptList(state, { payload }) {
      return { ...state, deptList: payload }
    },
    setUserList(state, { payload }) {
      return { ...state, userList: payload }
    },
  },

  effects: {
    *getDepts({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(transcript.getDepts, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      if (status === 200) {
        yield put({ type: 'transcript/setDeptList', payload: resData })
        successCallback?.(resData)
      } else {
        errorCallback?.()
      }
    },

    *getCampList({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(transcript.getCamps, {
        params: {
          keyword: payload?.keyword ?? '',
          pageIndex: payload?.pageIndex ?? 0,
          pageSize: payload?.pageSize ?? 10,
          accountId: get(account, 'accountId'),
        },
      })
      const { status, data: resData } = response
      if (status === 200) {
        successCallback?.(resData)
      } else {
        errorCallback?.()
      }
    },

    *getUsers({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(transcript.getUsers, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      if (status === 200) {
        yield put({ type: 'transcript/setUserList', payload: resData })
        successCallback?.(resData)
      } else {
        errorCallback?.()
      }
    },

    *exportDeptReports({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const { campaignIds, formats } = payload
      const response = yield call(transcript.exportDeptReports, {
        campaignIds,
        formats,
        accountId: get(account, 'accountId'),
      })
      const { status } = response
      if (status === 200) {
        downloadExportedReports(response, `成績單部門報告_${todayDateSuffix()}`)
        successCallback?.()
      } else {
        errorCallback?.()
      }
    },

    *exportUserReports({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const { campaignId, userIds, formats } = payload
      const response = yield call(transcript.exportUserReports, {
        campaignId,
        userIds,
        formats,
        accountId: get(account, 'accountId'),
      })
      const { status } = response
      if (status === 200) {
        downloadExportedReports(response, `成績單個人報告_${todayDateSuffix()}`)
        successCallback?.()
      } else {
        errorCallback?.()
      }
    },

    *sendDeptReports({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const { campaignIds, formats, recipientEmails, scheduledTime } = payload
      const response = yield call(transcript.sendDeptReports, {
        campaignIds,
        formats,
        recipientEmails,
        scheduledTime,
        accountId: get(account, 'accountId'),
      })
      const { status, data: resData } = response
      if (status === 200) {
        successCallback?.(resData)
      } else {
        errorCallback?.(resData?.message)
      }
    },

    *sendUserReports({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const { campaignId, userIds, formats, scheduledTime } = payload
      const response = yield call(transcript.sendUserReports, {
        campaignId,
        userIds,
        formats,
        scheduledTime,
        accountId: get(account, 'accountId'),
      })
      const { status, data: resData } = response
      if (status === 200) {
        successCallback?.(resData)
      } else {
        errorCallback?.(resData?.message)
      }
    },

    *getDeptEmailPreview({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(transcript.getDeptEmailPreview, {
        campaignId: payload.campaignId,
        accountId: get(account, 'accountId'),
      })
      const { status, data: resData } = response
      if (status === 200) {
        successCallback?.(resData)
      } else {
        errorCallback?.(resData?.message)
      }
    },

    *getUserEmailPreview({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(transcript.getUserEmailPreview, {
        campaignId: payload.campaignId,
        userHisId: payload.userHisId,
        accountId: get(account, 'accountId'),
      })
      const { status, data: resData } = response
      if (status === 200) {
        successCallback?.(resData)
      } else {
        errorCallback?.(resData?.message)
      }
    },
  },
}
